<template>
    <v-overlay :absolute="true">
        <v-card :loading="loading" class="mx-auto" flat light>
            <v-form class="m-3 p-3">
                <v-text-field
                    v-model="fileName"
                    label="Dateiname"
                    required
                ></v-text-field>
                <v-select
                    v-model="subdirectory"
                    :items="subdirectories"
                    label="Unterordner"
                    required
                ></v-select>
                <v-text-field
                    v-model="student"
                    label="ID"
                    required
                ></v-text-field>

                <v-btn
                    class="ml-4"
                    @click.stop="cancel"
                >Abbrechen
                </v-btn>

                <v-btn
                    class="ml-1"
                    color="green lighten-2"
                    @click.stop="update"
                >Speichern
                </v-btn>

            </v-form>
        </v-card>
    </v-overlay>
</template>

<script>
import swal from "sweetalert";

export default {
    name: "Edit",

    data() {
        return {
            file_id: "",
            newName: "",
            fileName: "",
            student: "",
            subdirectory: "",
            subdirectories: [],
            endpoints: Object,
        }
    },
    methods: {
        async loadSubs() {

            let url = this.endpoints.subdirectories.url

            await fetch(url)
                .then(response => response.json())
                .then((data) => this.subdirectories = data);

        },

        async fileInfo() {

            let url = this.endpoints.fileInfo.url
                .replace(new RegExp("{student_id}", "g"), this.student)
                .replace(new RegExp("{name}", "g"), this.newName);

            await fetch(url)
                .then(response => response.json())
                .then((data) => {
                    this.file_id = data.id
                    this.fileName = data.org_FileName
                    this.subdirectory = data.org_SubFolder
                });

        },

        open(fileName, student, endpoints) {
            this.newName = fileName;
            this.student = student;
            this.endpoints = endpoints;
            this.loadSubs()
            this.fileInfo()

        },

        cancel() {
            this.$emit("cancel");
        },

        async update() {
            if (this.fileName === "") {
                swal("Fehler", "Bitte einen Dateinamen angeben.", "error");
                return;
            }

            if (this.student === "") {
                swal("Fehler", "Bitte eine Schüler ID angeben.", "error");
                return;
            }

            let url = this.endpoints.update.url
                .replace(new RegExp("{file_id}", "g"), this.file_id)

            let payload = {
                student: this.student,
                fileName: this.fileName.replace("/", "-"),
                subdirectory: this.subdirectory
            }

            await fetch(url, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then(() => {
                    this.$emit("requestReload")
                    this.$emit("cancel");
                });
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-overlay__content {
    width: 90%;

    .files-list-wrapper {
        max-height: 250px;
        overflow-y: auto;
    }
}
</style>
